module.exports = __webpack_public_path__ + "static/media/confirm_pin.0e3f7aae.png";